import {
  FETCH_COMPANIES_SUCCESS,
  FETCH_CUSTOMERS_SUCCESS,
  COMPANIES_FAILURE,
  SAVE_COMPANIES,
  SAVE_CUSTOMER,
  DELETE_COMPANIES,
  SET_SELECTED_COMPANY_ID,
  SET_SELECTED_CUSTOMER_ID,
} from "actions/types";

import { produce } from "immer";

const initialState = {
  Companies: [],
  Customers: [],
  selectedCompanyId: -1,
  selectedCustomerId: -1,
  error: "",
};

const companiesReducer = (state = initialState, action) =>
  produce(state, (draft) => {
    var key;
    switch (action.type) {
      case FETCH_COMPANIES_SUCCESS:
        draft.Companies = action.payload;
        draft.error = "";
        break;
      case FETCH_CUSTOMERS_SUCCESS:
        draft.Customers = action.payload;
        draft.error = "";
        break;
      case COMPANIES_FAILURE:
        draft.error = action.payload;
        break;
      case SAVE_COMPANIES:
        key = draft.Companies.findIndex(
          (C) => parseInt(C.id) === parseInt(action.payload.id)
        );
        if (key === -1) {
          //new record
          draft.Companies = [...draft.Companies, action.payload];
        } else {
          draft.Companies[key] = action.payload;
        }
        draft.selectedCompanyId = -1;
        break;
      case SAVE_CUSTOMER:
        key = draft.Customers.findIndex(
          (C) => parseInt(C.id) === parseInt(action.payload.id)
        );
        if (key === -1) {
          //new record
          draft.Customers = [...draft.Customers, action.payload];
        } else {
          draft.Customers[key] = action.payload;
        }
        draft.selectedCustomerId = -1;
        break;
      case DELETE_COMPANIES:
        key = draft.Customers.findIndex(
          (C) => parseInt(C.id) === parseInt(action.payload.id)
        );
        draft = { Companies: draft.Companies.splice(key, 1) };
        draft.selectedCompanyId = -1;
        draft.selectedCustomerId = -1;
        break;
      case SET_SELECTED_COMPANY_ID:
        draft.selectedCompanyId = parseInt(action.payload);
        break;
      case SET_SELECTED_CUSTOMER_ID:
        draft.selectedCustomerId = parseInt(action.payload);
        break;
      default:
        return state;
    }
  });

export default companiesReducer;
